export default __webpack_public_path__ + "static/media/image_icon.402c3bcf.svg";